import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, OnDestroy, Output, ViewChild, ElementRef } from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileService} from "../../borrower-app/src/app/services/file.service";
import { PdfPasswordModalComponent } from "../../borrower-app/src/app/portals-common/task-information/add-files-to-task-dialog/pdf-password-modal/pdf-password-modal.component";
import { FileUploadModel } from "../../borrower-app/src/app/models/tasks/file-upload.model";


@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit, OnDestroy {

  @Output()
  uploadClicked = new EventEmitter<FileUploadModel[]>();

  private _isUploading: boolean = false;
  private _progressInterval: any = null;

  @Input()
  set isUploading(value: boolean) {
    this._isUploading = value;
    if (value) {
      this.startProgressPolling();
    } else {
      this.stopProgressPolling();
    }
    this._cdr.detectChanges();
  }
  get isUploading(): boolean {
    return this._isUploading;
  }

  public files: FileUploadModel[] = [];

  @ViewChild('fileDropRef') fileInputRef: ElementRef;

  constructor(public activeModal: NgbActiveModal,
              private _modalService: NgbModal,
              private readonly _fileService: FileService,
              private readonly _cdr: ChangeDetectorRef,
              private readonly _ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.stopProgressPolling();
  }

  private startProgressPolling(): void {
    if (this._progressInterval) return;
    this._progressInterval = setInterval(() => {
      this._cdr.detectChanges();
    }, 100);
  }

  private stopProgressPolling(): void {
    if (this._progressInterval) {
      clearInterval(this._progressInterval);
      this._progressInterval = null;
    }
  }

  protected onFilesSelected($event: any) {
    const selectedFiles = $event.target.files;
    this.onAfterFilesSelected(selectedFiles);
  }

  protected onFilesDropped($event: any) {
    const selectedFiles = $event;
    this.onAfterFilesSelected(selectedFiles);
  }

  protected onUploadClicked = () => {
    // The parent owns `isUploading` (via the input). Do NOT optimistically self-disable here:
    // if the parent's upload flow returns early (e.g. a failed pre-upload API call) without ever
    // driving `isUploading` true→false, a locally-set flag would never be reset and the Upload
    // button would stay permanently disabled. The disable + progress polling arrive via the
    // input setter once the parent sets `isUploading = true`. (LLS-138)
    this.uploadClicked.emit(this.files);
  }

  onFileDeleted() {
    // Reset the file input so the same file can be selected again
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
  }

  // Add to the existing array rather than replacing it: the parent holds the array emitted on
  // upload and removes the files that uploaded from it, which must include files added meanwhile.
  private onAfterFilesSelected = async (selectedFiles: any[]) => {
    for (const file of selectedFiles) {
      file.progress = 0;
      if (file.type === 'application/pdf') {
        const isPasswordProtected = await this._fileService.isPdfPasswordProtected(file);
        if (isPasswordProtected) {
          const modalRef = this._modalService.open(PdfPasswordModalComponent, {size: 'md', backdrop: 'static', centered: true});
          modalRef.componentInstance.file = file;

          modalRef.result
            .then((password: string) => {
              this.files.push({ file: file, progress: file.progress, password: password });
              this._cdr.detectChanges();
            })
        } else {
          this.files.push({file: file, progress: file.progress});
        }
      } else {
        this.files.push({file: file, progress: file.progress});
      }
    }
    this._cdr.detectChanges();
  }
}

